import { useEffect, useState } from "react";
import { Ban, ShieldCheck } from "lucide-react";
import { registerBanHost } from "../lib/compliance";

export const SiteBanDialogHost = () => {
  const [req, setReq] = useState(null);
  const [reason, setReason] = useState("");
  useEffect(() => { registerBanHost((r) => { setReason(""); setReq(r); }); return () => registerBanHost(null); }, []);
  if (!req) return null;
  const close = (choice) => { req.resolve(choice); setReq(null); };
  return (
    <div className="fixed inset-0 z-[70] bg-slate-900/50 backdrop-blur-sm grid place-items-center p-4">
      <div data-testid="site-ban-dialog" className="bg-white rounded-md w-full max-w-lg border border-rose-200 shadow-xl">
        <div className="px-5 py-4 border-b border-rose-100 bg-rose-50 flex items-center gap-2">
          <Ban className="h-5 w-5 text-rose-600" />
          <h3 className="font-display text-lg font-bold text-rose-900">Agent interdit sur ce site</h3>
        </div>
        <div className="p-5 space-y-3">
          <p className="text-sm text-slate-700" data-testid="site-ban-message">{req.message}</p>
          {req.can_force && <textarea data-testid="site-ban-reason" className="input h-20" value={reason} onChange={(e) => setReason(e.target.value)}
            placeholder="Motif obligatoire (conservé dans le journal d'activité)" />}
        </div>
        <div className="px-5 py-4 border-t border-slate-100 flex justify-end gap-2">
          <button data-testid="site-ban-cancel" onClick={() => close(null)} className="px-4 py-2 text-sm rounded-md border border-slate-300 hover:bg-slate-50">{req.can_force ? "Annuler" : "Compris"}</button>
          {req.can_force && <button data-testid="site-ban-force" disabled={reason.trim().length < 3} onClick={() => close({ reason: reason.trim() })}
            className="inline-flex items-center gap-2 px-4 py-2 text-sm font-semibold rounded-md bg-rose-600 text-white hover:bg-rose-700 disabled:opacity-50"><ShieldCheck className="h-4 w-4" />Forcer l'affectation</button>}
        </div>
      </div>
    </div>
  );
};

export const BanConflictsDialog = ({ items, onClose }) => (
  <div className="fixed inset-0 z-[70] bg-slate-900/50 backdrop-blur-sm grid place-items-center p-4" onClick={onClose}>
    <div data-testid="ban-conflicts-dialog" className="bg-white rounded-md w-full max-w-lg border border-amber-200 shadow-xl" onClick={(e) => e.stopPropagation()}>
      <div className="px-5 py-4 border-b border-amber-100 bg-amber-50 flex items-center gap-2">
        <Ban className="h-5 w-5 text-amber-600" />
        <h3 className="font-display text-lg font-bold text-amber-900">Vacations à réaffecter ({items.length})</h3>
      </div>
      <div className="p-5 space-y-2">
        <p className="text-sm text-slate-600">Ces agents viennent d'être interdits mais sont encore planifiés sur ce site. Les vacations n'ont pas été modifiées ; elles sont signalées dans le planning.</p>
        <ul className="max-h-64 overflow-y-auto divide-y divide-slate-100 border border-slate-200 rounded-md" data-testid="ban-conflicts-list">
          {items.map((v) => <li key={v.id} className="px-3 py-1.5 text-sm">{v.date.split("-").reverse().join("/")} · {v.start_time}–{v.end_time} · <b>{v.agent_name}</b></li>)}
        </ul>
      </div>
      <div className="px-5 py-4 border-t border-slate-100 flex justify-end">
        <button data-testid="ban-conflicts-close" onClick={onClose} className="px-4 py-2 text-sm font-semibold rounded-md bg-slate-900 text-white">Compris</button>
      </div>
    </div>
  </div>
);
